<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">
        <div>
            <h2 class="text-center mx-auto max-w-6xl text-2xl md:text-3xl lg:text-4xl font-semibold mb-10" v-html="dataLocale.data.title">

            </h2>
            <p class="text-lg md:text-xl text-center max-w-3xl mx-auto  ">
                {{ dataLocale.data.description }}
            </p>

        </div>
    </div>
</template>
<script lang="ts" setup>
import DataLocale from '~~/config/interface/DataLocale';

const dataLocale = new DataLocale([
    {
        locale: "en",
        title: "Most features are available for <span class='down-mark-line'>FREE</span>",
        description: "Some advanced functions are charged annually or monthly, providing more functionality and technical support. Whether you pay or not, we will fulfill your trust."
    },
    {
        locale: "vi",
        title: "Hầu hết các tính năng đều miễn phí",
        description: "Một số tính năng nâng cao được tính phí hàng năm hoặc hàng tháng, cung cấp nhiều chức năng và hỗ trợ kỹ thuật hơn. Bạn có thanh toán hay không, chúng tôi sẽ đáp ứng niềm tin của bạn."
    },
    {
        locale: "de",
        title: "Die meisten Funktionen sind <span class='down-mark-line'>kostenlos</span>",
        description: "Einige erweiterte Funktionen werden jährlich oder monatlich berechnet und bieten mehr Funktionalität und technischen Support. Egal, ob Sie bezahlen oder nicht, wir erfüllen Ihr Vertrauen."
    },
    {
        locale: "fr",
        title: "La plupart des fonctionnalités sont disponibles <span class='down-mark-line'>GRATUITEMENT</span>",
        description: "Certaines fonctions avancées sont facturées annuellement ou mensuellement, offrant plus de fonctionnalités et de support technique. Que vous payiez ou non, nous répondrons à votre confiance."
    },
    {
        locale: "it",
        title: "La maggior parte delle funzioni sono disponibili <span class='down-mark-line'>GRATIS</span>",
        description: "Alcune funzioni avanzate sono a pagamento annualmente o mensilmente, offrendo maggiore funzionalità e supporto tecnico. Che paghiate o meno, noi saremo all'altezza della vostra fiducia."
    }
    ,
    {
        locale: "es",
        title: "La mayoría de las funciones están disponibles de forma <span class='down-mark-line'>GRATUITA</span>",
        description: "Algunas funciones avanzadas se cobran anual o mensualmente, proporcionando más funcionalidad y soporte técnico. Ya sea que pague o no, cumpliremos con su confianza."
    },
    {
        locale: "ja",
        title: "ほとんどの機能が<span class='down-mark-line'>無料</span>で利用可能",
        description: "一部の高度な機能には、年次または月次で料金が発生し、より高度な機能と技術サポートが提供されます。お支払いいただくかどうかに関わらず、信頼に応えます。"
    },
    {
        locale: "zh",
        title: "大多数功能都是<span class='down-mark-line'>免费</span>的",
        description: "一些高级功能按年度或月度收费，提供更多功能和技术支持。无论您付款与否，我们都会履行您的信任。"
    },
    {
        locale: "pt",
        title: "A maioria das funcionalidades está disponível <span class='down-mark-line'>GRATUITAMENTE</span>",
        description: "Algumas funções avançadas são cobradas anualmente ou mensalmente, proporcionando mais funcionalidade e suporte técnico. Seja você pagante ou não, nós cumpriremos sua confiança."
    },

])
</script>